import { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import RackLifecycleModal from './RackLifecycleModal';

RackLifecycleButton.propTypes = {
  rackName: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object])),
    PropTypes.func,
    PropTypes.object
  ])
};

RackLifecycleButton.defaultProps = {
  rackName: '',
  variant: 'contained',
  color: 'primary',
  disabled: false
};

export default function RackLifecycleButton({ rackName, variant, color, disabled, sx = [] }) {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
    <>
      <Button
        data-testid="rack-lifecycle-button"
        onClick={openModal}
        variant={variant}
        sx={{ ...sx }}
        disabled={disabled}
        startIcon={<AutoModeIcon />}
        color={color}
      >
        Lifecycle
      </Button>

      <RackLifecycleModal isOpen={modalOpen} closeHandler={closeModal} rackName={rackName} />
    </>
  );
}
